module.exports = __webpack_public_path__ + "static/media/prev-icon.611f798d.svg";